import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";

// Generate or retrieve session ID
const getSessionId = (): string => {
  let sessionId = sessionStorage.getItem("page_view_session_id");
  if (!sessionId) {
    sessionId = crypto.randomUUID();
    sessionStorage.setItem("page_view_session_id", sessionId);
  }
  return sessionId;
};

// Get selected city ID from localStorage
const getSelectedCityId = (): string | null => {
  return localStorage.getItem("selectedCity") || null;
};

export const usePageViewTracking = () => {
  const location = useLocation();
  const lastTrackedPath = useRef<string>("");

  useEffect(() => {
    const trackPageView = async () => {
      // Avoid tracking the same path multiple times in quick succession
      if (lastTrackedPath.current === location.pathname) {
        return;
      }

      // Don't track admin pages
      if (location.pathname.startsWith("/admin")) {
        return;
      }

      lastTrackedPath.current = location.pathname;

      const sessionId = getSessionId();
      const cityId = getSelectedCityId();

      try {
        // Get current user if authenticated
        const { data: { user } } = await supabase.auth.getUser();

        await supabase.from("page_views").insert({
          page_path: location.pathname,
          city_id: cityId,
          user_id: user?.id || null,
          session_id: sessionId,
          referrer: document.referrer || null,
        });
      } catch (error) {
        // Silently fail - don't disrupt user experience
        console.error("Failed to track page view:", error);
      }
    };

    trackPageView();
  }, [location.pathname]);
};
